var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center bg-white text-blue-400 py-8"},[_vm._v(" Campaign dashboard ")])}
var staticRenderFns = []

export { render, staticRenderFns }